import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LoginService } from '../user-login/login.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { CurveService } from '../curve-service/curve.service';
import { AlloyService } from 'src/app/shared/alloy/alloy.service';
import { DatePipe } from '@angular/common';

@Component({
    selector: 'app-scatter-plot',
    templateUrl: './scatter-plot.component.html',
    styleUrls: ['./scatter-plot.component.css'],
    standalone: false
})
export class ScatterPlotComponent implements OnInit {
  role: string;
  serverErrorMessages: string;
  alloys = [];
  drp_grade1 = [];
  graphs = [];
  allgraphs;
  basicData: any;
  loading;

  parameters = ['LT', 'LET', 'HET', 'δ or R', 'ST', 'Gr. Fact', 'CF', 'ACE', 'PS', 'PE', 'SE'];
  parameter;
  grade;
  iron1;
  iron2;
  startDate;
  endDate;
  alert = 'Please select the parameters.';
  grades = ['420/10', '500/7', 'SiBoDur500', 'CGI-FeSiLa', 'SiMi406'];
  filterForm = new FormGroup({
    grade: new FormControl('', [Validators.required]),
    parameter: new FormControl('', [Validators.required]),
    startDate: new FormControl(''),
    endDate: new FormControl(''),
    iron1: new FormControl('', [Validators.required]),
    iron2: new FormControl('', [Validators.required]),
  });
  title = 'Process Tracker';
  type = 'ScatterChart';
  data = [];
  documentStyle = getComputedStyle(document.documentElement);
  textColor = this.documentStyle.getPropertyValue('--text-color');
  textColorSecondary = this.documentStyle.getPropertyValue('--text-color-secondary');
  surfaceBorder = this.documentStyle.getPropertyValue('--surface-border');

  width;
  height;
  basicOptions: {
    maintainAspectRatio: boolean,
    plugins: { legend: { labels: { color: any }; onClick: any } };
    scales: {
      y: {
        beginAtZero: boolean;
        ticks: { color: any; min: number; max: number };
        grid: { color: any; drawBorder: boolean };
      };
      x: { ticks: { color: any }; grid: { color: any; drawBorder: boolean } };
    };
  };

  constructor(
    private loginService: LoginService,
    private curveService: CurveService,
    private router: Router,
    private alloyService: AlloyService,
    private datePipe: DatePipe
  ) {}

  ngOnInit(): void {
    if (this.loginService.shouldBlock()) {
      alert('Low Balance! Redirecting...');
      this.router.navigateByUrl('/home');
    }
    if (this.loginService.isLoggedIn()) {
      this.loginService.getUserProfile().subscribe(
        (res) => {
          this.role = res['user'].role.toString();
          //console.log('User', this.role);
          this.getAllAlloys();
          this.getAllGraphs();
        },
        (err) => {
          //console.log('Didnt get logged in user', err);
          this.serverErrorMessages = err.error.message;
        }
      );
    } else {
      alert('PLEASE LOGIN');
      this.router.navigateByUrl('/signin');
    }
    this.width = 950;
    this.height = 500;
    this.loading = false;

    this.basicOptions = {
      maintainAspectRatio: false,
      plugins: {
        legend: {
          labels: {
            color: this.textColor,
          },
          onClick: function (e) {
            e.native.stopPropagation();
          },
        },
      },
      scales: {
        y: {
          beginAtZero: false,
          ticks: {
            color: this.textColorSecondary,
            min: 0,
            max: 0,
          },
          grid: {
            color: this.surfaceBorder,
            drawBorder: false,
          },
        },
        x: {
          ticks: {
            color: this.textColorSecondary,
          },
          grid: {
            color: this.surfaceBorder,
            drawBorder: false,
          },
        },
      },
    };
  }

  getAllAlloys() {
    this.alloyService.getAlloy().subscribe(
      (res) => {
        this.alloys = res['alloyDatas'];
        for (var x of this.alloys) {
          if (x.greyIron.baseIron) {
            x.iron1 = 'Grey Iron';
            x.iron2 = 'Base Iron';
            this.drp_grade1.push(x.grade);
          } else if (x.greyIron.finalIron) {
            x.iron1 = 'Grey Iron';
            x.iron2 = 'Final Iron';
          } else if (x.ductileIron.baseIron) {
            x.iron1 = 'Ductile Iron';
            x.iron2 = 'Base Iron';
            this.drp_grade1.push(x.grade);
          } else if (x.ductileIron.finalIron) {
            x.iron1 = 'Ductile Iron';
            x.iron2 = 'Final Iron';
          }
        }
        //  console.log('Got alloys', this.alloys)
      },
      (err) => {
        //console.log('Error getting alloys', err);
        this.serverErrorMessages = err.error.message;
      }
    );
  }

  getAllGraphs() {
    this.curveService.getCurveData().subscribe(
      (res) => {
        //  console.log('got all graphs', res);
        this.allgraphs = res['curveDatas'];
        for (var x of this.allgraphs) {
          for (var y of this.alloys) {
            if (y._id == x.alloyId) {
              x.iron1 = y.iron1;
              x.iron2 = y.iron2;
              x.grade = y.grade;
              break;
            }
          }
        }
        this.graphs = this.allgraphs;
        this.loading = false;
      },
      (err) => {
        //console.log('error getting all graphs', err);
        this.serverErrorMessages = err.error.message;
      }
    );
  }

  filter() {
    this.parameter = this.filterForm.get('parameter').value;
    this.grade = this.filterForm.get('grade').value;
    this.startDate = this.filterForm.get('startDate').value;
    this.endDate = this.filterForm.get('endDate').value;
    this.iron1 = this.filterForm.get('iron1').value;
    this.iron2 = this.filterForm.get('iron2').value;

    this.graphs = [];
    this.data = [];
    for (var x of this.allgraphs) {
      var d = this.transformDate(x.createdAt);
      var start = this.transformDate(this.startDate);
      var end = this.transformDate(this.endDate);

      if (((start != null && end != null && d >= start && d <= end) || (!start && !end))
        && x.thermalValues != null && x.grade == this.grade && x.iron1 == this.iron1
        && x.iron2 == this.iron2) {
        var min = 0;
        var max = 0;
        switch (this.parameter) {
          case 'TL':
            (min = 1100), (max = 1300);
            if (x.thermalValues.LiquidusTemperature > 0 && x.thermalValues?.LiquidusTemperature < max) {
              this.data.push([d, x.thermalValues.LiquidusTemperature, x.heatId]);
            }
            break;
          case 'TE_Low':
            (min = 1000), (max = 1350);
            if (x.thermalValues.TELow > 0 && x.thermalValues?.TELow < max) {
              this.data.push([d, x.thermalValues.TELow, x.heatId]);
            }
            break;
          case 'TE_High':
            (min = 1000), (max = 1350);
            if (x.thermalValues.TEHigh > 0 && x.thermalValues?.TEHigh < max) {
              this.data.push([d, x.thermalValues.TEHigh, x.heatId]);
            }
            break;
          case 'R':
            (min = 0), (max = 15);
            if (x.thermalValues.Recalescence > 0 && x.thermalValues?.Recalescence < max) {
              this.data.push([d, x.thermalValues.Recalescence, x.heatId]);
            }
            break;
          case 'TSol':
            (min = 1000), (max = 1350);
            if (x.thermalValues.SolidusTemperature > 0 && x.thermalValues?.SolidusTemperature < max) {
              this.data.push([d, x.thermalValues.SolidusTemperature, x.heatId]);
            }
            break;
          case 'GF':
            (min = 20), (max = 100);
            if (x.thermalValues.GRF1 > 0 && x.thermalValues?.GRF1 < max) {
              this.data.push([d, x.thermalValues.GRF1, x.heatId]);
            }
            break;
          case 'CF':
            (min = 20), (max = 100);
            if (x.thermalValues.GRF2 > 0 && x.thermalValues?.GRF2 < max) {
              this.data.push([d, x.thermalValues.GRF2, x.heatId]);
            }
            break;
          case 'ACEL':
            (min = 2.8), (max = 5);
            if (x.thermalValues.ACEL > 0 && x.thermalValues?.ACEL < max) {
              this.data.push([d, x.thermalValues.ACEL, x.heatId]);
            }
            break;
          case 'PS':
            (min = 0), (max = 100);
            if (x.thermalValues.primaryShrinkage > 0 && x.thermalValues?.primaryShrinkage < max) {
               this.data.push([d, x.thermalValues.primaryShrinkage, x.heatId]);
            }
            break;
          case 'PE':
            (min = 0), (max = 100);
            if (x.thermalValues.primaryExpansion > 0 && x.thermalValues?.primaryExpansion < max) {
              this.data.push([d, x.thermalValues.primaryExpansion, x.heatId]);
            }
            break;
          case 'SE':
            (min = 0), (max = 100);
            if (x.thermalValues.secondaryExpansion > 0 && x.thermalValues?.secondaryExpansion < max) {
              this.data.push([d, x.thermalValues.secondaryExpansion, x.heatId]);
            }
            break;
        }
      }
    }
    if (this.data.length == 0)
    {
      this.alert = 'No matching curves.';
      return;
    }
    let xAxisVal = this.data.map((item) => item[2]);
    let yAxisVal = this.data.map((item) => item[1]);
    this.basicData = {
      labels: xAxisVal,
      datasets: [
        {
          label: this.parameter,
          data: yAxisVal,
          borderColor: ['#2e354f'],
          borderWidth: 1,
          backgroundColor: "#fffff"
        },
      ],
    };
  }

  reset() {
    this.graphs = this.allgraphs;
    this.alert = 'Please select the parameters.';
    this.filterForm.reset();
    this.data = [];
  }

  transformDate(x) {
    return this.datePipe.transform(x, 'yyyy-MM-dd');
  }
}
